// src/pages/Companies.js
import React from 'react';

import { assets } from '../../assets/asset_importer';

const PartnershipOptions = () => {
  return (
    <div className="page companies-page">
      <section className="page-header">
        <div className="container">
          <h1>Integralis Partnership Options</h1>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          
          <div className="info-card mb-2">
            <p>Integralis, the international student organization for natural science students
at the University of Helsinki, is happy to present our partnership options. With
approximately 200 official members and countless alumni and enrolled in
various study tracks, Integralis is proud to be a hub of academic excellence
and cultural diversity. Our members have come from over 50 countries and six
continents, allowing us to foster a global perspective within the academic
community. 
We currently represent 35 different nationalities. <br></br>
Integralis
welcomes you to explore our partnership opportunities, creating mutually
beneficial collaborations that support your organization's growth and mission.
Join us in shaping the future of the University of Helsinki's international
community.
            </p>
                          
          </div>
          
          <div className="info-card mb-2">
            <h2>Partnerships</h2>
            <p>Integralis ry aims to establish a mutually beneficial partnership that
maximizes value and long-term impact for both parties. To facilitate this, we
have outlined example partnership packages to illustrate potential
collaboration models. We also welcome your vision and ideas for how this
partnership could best support your goals. Below, you will find individual
partnership options as well as sample partnership packages.
            </p>
            <h2>Transparency Commitment</h2>
            <p>At the end of each fiscal year, Integralis ry will provide an itemized bill of
expenses for each partner, detailing how contributions specifically improved
student culture, physical activities, and community events.</p>
                          
          </div>

          <div className="info-card mb-2">
            <h2>Example Benefit Options</h2>
            <h3>Official Partner:</h3>
            <p>With all our offerings, your company will earn visibility with our members, alumni
and stakeholders as we list you as an official partner on all our communication
channels: our Telegram (~ 500 members), our Instagram (~ 600 followers),
and our website. You will also be able to use our logo in your social media
channels as well as your website.</p>

            <p>As a partner, you will receive clear and transparent reporting on how your
contribution is allocated. This includes insights into how funds support the
development of students’ physical activities, cultural initiatives, and other
community-enhancing projects carried out in collaboration with the Events
Committee.
</p>
            <h3>Official Partner:</h3>
            <p>As an official Partner, your company will be able to engage with our members by
posting job opportunities and other offerings through all the Integralis
communication channels, including:</p>
<ol>
<li>The Integralis Telegram Jobs and Announcements channels</li>
<li>Integralis official Mailing list</li>
<li>Integralis social media page on Instagram</li>
</ol>
            
            <h3>Company Excursion:</h3>
            <p>With this benefit, Integralis will collaborate with your company to create a
company excursion for our members.</p>
<p>At the company excursion, you can present your company, discuss available
opportunities at your company, and offer a case study for our members to
challenge. A company excursion can also include a hackathon for our
members.</p>
<p>This company excursion can be at your premises, organised at a University of
Helsinki facility or online, whichever is most convenient for you!</p>

            <h3>Event Cooperation:</h3>
            <p>With event cooperation, Integralis will collaborate with your company to host an
Integralis-led event to boost your engagement with our members.</p>
            <p>This will be done before the event through event advertising, and during the event
through a representative (an employee of your company or Integralis proxy)
will increase awareness of your company's opportunities and offers. Example
events include:</p>
<ol>
      <li>Sitsis</li>
      <li>Parties</li>
      <li>Integralis Excursions (such as water park, laser tag, and rock-climbing
excursions)</li>
<li>Sauna evenings</li>
<li>Barbeques etc.</li>
</ol>

            <h3>Vujut Cooperation:</h3>
            <p>In 2026, Integralis is hosting our 7th-anniversary ball. With the Vujut Cooperation
benefit, we look to increase your brand awareness among our members at this
celebration!</p>
            <p>With this benefit, an Integralis representative will work with you to create the best
possible representation.</p>
            <p>Examples of what we can do include:</p>

<ol>
        <li>Including your logo on the cover of all the Vujut name cards and songbooks </li>
        <li>Tagging all beverages with your logo and giving company mentions during
food announcements.</li>
        <li> Providing speech opportunities for your representatives, logo placement on
event posters and photo walls, and the option to display your company
banner at the event venue (if available).</li>
</ol>

            <h3>Company Ambassador:</h3>
            <p>With this benefit, we will assign one of our active members as your company
ambassador/representative. This representative would then act as a first point
of contact for possible career days, company hosted events etc.</p>
            <p>Due to the flexible nature of this benefit, we highly encourage you to contact us
about further information and discussion!
</p>
          </div>
          <div className="info-card mb-2">
            <h2>Example Partnership Packages</h2>
            <table>
              <thead>
              <tr>
                <th>Benefit</th>
                <th>Standard</th>
                <th>Premium</th>
                <th>Premium+</th>
              </tr>
              <tr>
                <th></th>
                <th>300 €</th>
                <th>850 €</th>
                <th>1100 €</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>Official Partner</td>
                <td>✔</td>
                <td>✔</td>
                <td>✔</td>
              </tr>
              <tr>
                <td>Talent recruitment</td>
                <td>✔</td>
                <td>✔</td>
                <td>✔</td>
              </tr>
              <tr>
                <td>Event Cooperation</td>
                <td>✖</td>
                <td>✔ / Single event</td>
                <td>✔ / Multi event</td>
              </tr>
              <tr>
                <td>Company Excursion</td>
                <td>✖</td>
                <td>✔ / Single excursion</td>
                <td>✔ / Multi excursion</td>
              </tr>
              <tr>
                <td>Vujut Cooperation</td>
                <td>✖</td>
                <td>✖</td>
                <td>✔</td>
              </tr>
              </tbody>
            </table>
            <p> Combining different options is possible, you can negotiate the total cost of your preferred kind
of partnership with Integralis ry.</p>
            <p>
              We also want to emphasize, that not all partnership options need to be
monetary. Goods, food for events, snacks, drinks, merch etc. are all negotiable
with us.
            </p>
          </div>

          <div className="info-card mb-2">
            <h2>Overalls Partnership</h2>
            <p>Integralis ry also offers you an opportunity to sponsor our overalls. Overalls are
an integral part of student life, and they are worn by our students at almost all
Integralis events, making it a great opportunity for you to advertise your
company. Our overalls options are listed below.</p>
          <div className='two-column-text'>
            <img src={assets.images.partnerships.overalls_placement} alt="Overalls Placement" className="overalls-photo" />
            <div>
            Single colour black or white prints:
            <ul>
              <li> Small Ad = 300 €</li>
              <li> Medium Ad = 500 €</li>
              <li> Large Ad = 750 €</li>
            </ul>
            <br></br>
            Multi colour print:
            <ul>
              <li> Small Ad = 430 €</li>
              <li> Medium Ad = 680 €</li>
              <li> Large Ad = 930 €</li>
            </ul>
            <br></br>
            Each year we sell about 50 overalls to our freshers
and other interested students.
            </div>
          </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default PartnershipOptions;


